/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { FabNavItem } from '@fabric/components/common';

const globalAuthority = 'general-user';
const hrAuthority = 'hr';
const managerAuthority = 'manager';


export const appNavItems: FabNavItem[] = [
  {
    name: 'Home',
    route: '',
    authority: globalAuthority,
    iconName: 'home',
  },
  {
    name: 'Vacation',
    route: 'personal',
    authority: globalAuthority,
  },
  {
    name: 'Work Abroad',
    route: 'work-abroad',
    authority: globalAuthority,
  },
  {
    name: 'Team',
    route: 'team',
    authority: managerAuthority,
  },
  {
    name: 'Company',
    route: 'company',
    authority: hrAuthority,
  }
];
